import getPrototypeOf from "./getPrototypeOf.js";
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = getPrototypeOf(t)););
  return t;
}
export { _superPropBase as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/superPropBase.js
// module id = 1086
// module chunks = 0